import { Tag } from '@/admin-shared-modules/typings'
import { GET } from '@/admin-shared-modules/utils/ajax'
import _ from 'lodash'

class BookSortStore {
  state = {
    flattenTags: [] as Tag[],
    items: [] as Tag[],
    loading: false
  }

  async fetch() {
    //if (this.state.items.length) return
    this.state.loading = true

    try {
      const res = await GET(`tag`, {
        data: { public: 0 }
      })
      this.state.flattenTags = res.data
      this.state.items = this.state.flattenTags as Tag[]
    } catch (e) {
      console.error(e)
    } finally {
      this.state.loading = false
    }
  }

  getTagById(id: number) {
    return _.clone(_.find(this.state.flattenTags, { id }))
  }
}

export default new BookSortStore()
